// The timeout to set on the XHR request in milliseconds.
// Should be longer than Excess receiver idle_timeout (120 sec).
var REQUEST_TIMEOUT = 122000;
// Maximum number of attempts for failed network requests.
var REQUEST_MAX_ATTEMPTS = 3;

/**
 * Send events to the excess tracking endpoint.
 *
 * @param {string} url The URL to POST events to.
 * @param {Object[]} events An array of event objects.
 * @param {Function} [callback] An optional function to be called when tracking is completed.
 */
function postEventsToExcess(url, events, callback) {
  var attempts = 0;
  var postRequest = function () {
    attempts++;
    var request = new XMLHttpRequest();
    var requestChangeHandler = function () {
      if (request.readyState !== XMLHttpRequest.DONE) {
        return;
      }
      if (request.status !== 200) {
        // Failed to post events
        if (attempts < REQUEST_MAX_ATTEMPTS) {
          // Wait a second and try again
          setTimeout(function () {
            postRequest();
          }, 1000);
          return;
        }
        console.warn(
          "Failed to send events to excess after " + attempts + " attempts"
        );
      }
      callback && callback();
    };
    request.open("POST", url, true);
    request.timeout = REQUEST_TIMEOUT;
    request.setRequestHeader("Content-type", "application/json");
    request.send(JSON.stringify(events));
    request.onreadystatechange = requestChangeHandler;
  };

  postRequest();
}

module.exports = postEventsToExcess;
